import React from "react";

export const useScroll = () => {
  const htmlElRef = React.useRef(null);
  const executeScroll = () => window.scrollTo(0, htmlElRef.current.offsetTop);

  return [executeScroll, htmlElRef];
};
